import React from 'react';
import Paper from "@material-ui/core/Paper";
import {withStyles} from "@material-ui/styles";
import MuiTable from "../common/MuiTable";
import {
    exportReport
} from "../../util/ApiUtils";
import {NotificationManager, NotificationContainer} from "react-notifications";
import {Spinner} from "../common/Spinner";
import {
    addAuditPlanRevision,
    audit,
    auditPlan,
    auditPlanRevision,
    deleteAuditPlan, saveOrUpdateAudit,
    saveOrUpdateAuditPlan
} from "../../util/AuditPlanApiUtils";
import {BlueButton, GreenButton, GreyButton} from "../common/ButtonsConstants";
import {AddCircleOutlineTwoTone} from "@material-ui/icons";
import moment from "moment";
import CardHeader from "@material-ui/core/CardHeader";
import Modal from "@material-ui/core/Modal";
import {KeyboardDatePicker, MuiPickersUtilsProvider} from "@material-ui/pickers";
import MomentUtils from "@date-io/moment";
import TextField from "@material-ui/core/TextField";
import SignaturePad from "react-signature-canvas";
import CommonRevisionModal from "../common/CommonRevisionModal";
import Typography from "@material-ui/core/Typography";
import * as CommonUtils from "../../util/CommonUtils";
import { t } from '../../i18n';

const classes = (() => ({
    root: {
        width: '100%',
        overflowX: 'auto',
    },
    table: {
        minWidth: 650,
    },
}));

const columns = [
    {
        title: 'id',
        field: 'id',
        type: "numeric",
        hidden: true,
    },
    {
        title: t('auditPlan.columns.title'),
        field: 'title',
        type: "string",
        cellStyle: {
            width: '15%'
        }
    },
    {
        title: t('auditPlan.columns.criteria'),
        field: 'criteria',
        type: "string",
        cellStyle: {
            width: '15%'
        }
    },
    {
        title: t('auditPlan.columns.date'),
        field: 'date',
        type: "date",
        cellStyle: {
            width: '15%'
        }
    },
    {
        title: t('auditPlan.columns.auditorsAllocated'),
        field: 'auditorsAllocated',
        type: "string",
        cellStyle: {
            width: '15%'
        }
    },
    {
        title: t('auditPlan.columns.results'),
        field: 'results',
        type: "string",
        cellStyle: {
            width: '15%'
        }
    }
];

class AuditPlan extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            auditPlan: [],
            isLoading: true,
        };
        this.loadAuditPlan = this.loadAuditPlan.bind(this);
        this.handleSaveOrUpdate = this.handleSaveOrUpdate.bind(this);
        this.handleSaveOrUpdateAudit = this.handleSaveOrUpdateAudit.bind(this);
        this.handleDelete = this.handleDelete.bind(this);
        this.isValid = this.isValid.bind(this);
        this.showModal = this.showModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.onFooterEdit = this.onFooterEdit.bind(this);
        this.onFooterSave = this.onFooterSave.bind(this);
        this.clear = this.clear.bind(this);
        this.onDateChange = this.onDateChange.bind(this);
        this.handleTextChange = this.handleTextChange.bind(this);
        this.onSignatureEnd = this.onSignatureEnd.bind(this);
        this.addRevision = this.addRevision.bind(this);
    }

    sigPad = {};

    clear = () => {
        this.sigPad.clear()
    };

    addRevision(request) {
        addAuditPlanRevision(request)
            .then(response => {
                NotificationManager.success(t('app.notifications.success'), t('messages.revisionUpdated'), 5000);
                console.log('response');
                console.log(response);
                this.closeModal(response);
            }).catch(error => {
            console.log("error");
            console.log(error);
            NotificationManager.error(t('app.notifications.error'), t('messages.genericError'), 5000);
        });
    }

    onDateChange(event, date) {
        console.log(event); //null
        console.log('date', date); //whatever the date the user picked
        this.setState({
            ...this.state, date: moment(date, "DD/MM/YYYY"),
        });
    }

    handleTextChange({ target }) {
        this.setState({
            ...this.state, [target.name]: target.value
        });
    }

    componentDidMount() {
        this.loadAuditPlan(() => auditPlanRevision()
            .then(response => {
                console.log('Revision');
                console.log(response);
                this.setState({
                    latestRevision: response,
                    isLoading: false,
                    isEditing: false,
                });
            })
            .catch(error => {
                console.log(error);
            })
        )
    }

    loadAuditPlan(callback) {
        audit()
            .then(response => {
                console.log(response);
                this.setState({
                    id: response.id,
                    directorName: response.directorName,
                    signature: response.signature,
                    date: response.date,
                });
                auditPlan()
                    .then(response => {
                        console.log(response);
                        this.setState({
                            auditPlan: response
                        });
                        if (callback) {
                            callback();
                        }
                    })
                    .catch(error => {
                        console.log(error);
                    });
            })
            .catch(error => {
                console.log(error);
            });
    }

    handleSaveOrUpdateAudit(request) {
        console.log(request);
        saveOrUpdateAudit(request)
            .then((updatedObj) => {
                console.log("updated audit id " + updatedObj.id);
                console.log("updated audit " + updatedObj);
                console.log(this.state);
                NotificationManager.success(t('app.notifications.success'), t('messages.auditPlanUpdated'), 5000);
            }).catch(error => {
            console.log("error");
            console.log(error);
            NotificationManager.error(t('app.notifications.error'), t('messages.genericError'), 5000);
        });
    }

    handleSaveOrUpdate(request) {
        console.log(request);
        saveOrUpdateAuditPlan(request)
            .then((updatedObj) => {
                console.log("updated audit plan id " + updatedObj.id);
                console.log("updated audit plan " + updatedObj);
                console.log(this.state);
                this.loadAuditPlan();
                NotificationManager.success(t('app.notifications.success'), t('messages.auditPlanUpdated'), 5000);
            }).catch(error => {
            console.log("error");
            console.log(error);
            NotificationManager.error(t('app.notifications.error'), t('messages.genericError'), 5000);
        });
    }

    showModal() {
        this.setState({
            show: true
        });
    }

    closeModal(updatedRevision) {
        console.log("updatedRevision");
        console.log(updatedRevision);
        if (updatedRevision) {
            this.setState({
                show: false,
                latestRevision: updatedRevision,
            });
        } else {
            this.setState({
                show: false,
            });
        }
    }

    handleDelete(request) {
        console.log(request);
        deleteAuditPlan(request)
            .then(() => {
                this.loadAuditPlan();
                NotificationManager.success(t('app.notifications.success'), t('messages.auditPlanUpdated'), 5000);
            }).catch(error => {
            console.log("error");
            console.log(error);
            NotificationManager.error(t('app.notifications.error'), t('messages.genericError'), 5000);
        });
    }

    isValid(newData) {
        let isValid = newData.title && newData.title !== '';
        if (!isValid) {
            NotificationManager.error(t('app.notifications.error'), t('messages.validation.titleRequired'), 5000);
        }
        return isValid;
    }

    onFooterEdit() {
        this.setState({
            isEditing: true
        });
    }

    onFooterSave() {
        this.setState({
            isEditing: false
        }, () => {
            this.handleSaveOrUpdateAudit({
                id: this.state.id,
                signature: this.state.signature,
                date: this.state.date,
                directorName: this.state.directorName,
            });
        });
    }

    onSignatureEnd(value) {
        this.setState({
            signature: value
        });
    }

    render() {
        let { state } = this;
        let { classes } = this.props;
        if (state.isLoading) {
            return <Spinner/>;
        }
        const isRevision = (state.latestRevision.id !== null);
        let isDemo = this.props.currentUser && this.props.currentUser.isDemo;
        let isAuditor = CommonUtils.isAuditor(this.props.currentUser);
        let isViewer = CommonUtils.isViewer(this.props.currentUser);
        return <div>
                <Typography component="h2" variant="h5">
                    { t('auditPlan.title') }
                </Typography>
                <CardHeader
                    action={
                        <BlueButton
                             variant="contained"
                             color="secondary"
                             startIcon={<AddCircleOutlineTwoTone/>}
                             onClick={this.showModal}
                             size="small"
                             style={{marginRight: '10px'}}
                             disabled={isAuditor || isViewer}
                         >
                            { t('common.add') }
                         </BlueButton>
                    }
                    title={
                        <span style={{color: "darkblue"}}>
                            <p><b>{isRevision && `${t('context.common.revision')} ${state.latestRevision.number} ${t('context.common.author')}: ${state.latestRevision.author}`}</b></p>
                            <p><b>{ t('context.common.approvedFor') }: {state.latestRevision.approvedBy} {t('context.common.on')} {moment(state.latestRevision.date).format('DD/MM/YYYY')}</b></p>
                        </span>
                    }
                />
                <Paper className={classes.root} style={{ marginTop: '30px' }}>
                    <MuiTable
                        title={''}
                        columns={columns}
                        data={state.auditPlan}
                        onAdd={this.handleSaveOrUpdate}
                        onUpdate={this.handleSaveOrUpdate}
                        onDelete={this.handleDelete}
                        exportButton={!isDemo && !isViewer}
                        onExport={() => exportReport('/audit-plan/export')}
                        isValid={this.isValid}
                        pageSize={10}
                        allowUpdateDelete={(isAuditor || isViewer) ? 'no' : 'yes'}
                    />
                </Paper>
                {
                    state.isEditing ?
                        <div style={{ marginTop: "30px" }}>
                            <div style={{ width: "400px", height: "360px", paddingTop: "30px" }}>
                                <label>
                                    { t('auditPlan.signaturePrompt') }
                                </label>
                                <div style={{ clear: "both", borderStyle: "ridge", borderWidth: "1px", padding: "0px", display: "table-cell" }}>
                                    <SignaturePad
                                        canvasProps={{ width: "400px", height: "300px" }}
                                        onEnd={() => { console.log('onEnd called'); this.onSignatureEnd(this.sigPad.toDataURL('image/png')); }}
                                        ref={(ref) => {
                                            this.sigPad = ref;
                                            if (state.signature && this.sigPad) {
                                                this.sigPad.fromDataURL(state.signature, { width: 400, height: 300})
                                            }
                                        }}
                                    />
                                    <GreyButton onClick={this.clear}>
                                        { t('common.clear') }
                                    </GreyButton>
                                </div>
                            </div>
                            <div style={{ paddingTop: "60px" }}>
                                <TextField
                                    id="directorName"
                                    name="directorName"
                                    value={state.directorName}
                                    label={ t('auditPlan.labels.directorName') }
                                    onChange={this.handleTextChange}
                                    style={{ width: "300px"}}
                                />
                            </div>
                            <div style={{ paddingTop: "30px" }}>
                                <MuiPickersUtilsProvider utils={MomentUtils}>
                                    <KeyboardDatePicker
                                        disableToolbar
                                        autoOk
                                        variant="inline"
                                        format="DD/MM/YYYY"
                                        margin="normal"
                                        id="date"
                                        label={ t('auditPlan.labels.date') }
                                        name="date"
                                        value={state.date}
                                        onChange={ this.onDateChange }
                                        KeyboardButtonProps={{
                                            'aria-label': 'change date',
                                        }}
                                        style={{ width: "300px"}}
                                    />
                                </MuiPickersUtilsProvider>
                            </div>
                            <div style={{ paddingTop: "30px" }}>
                                <GreenButton
                                    variant="contained"
                                    color="secondary"
                                    startIcon={<AddCircleOutlineTwoTone/>}
                                    onClick={this.onFooterSave}
                                    size="small"
                                    style={{marginRight: '10px'}}
                                >
                                    { t('common.save') }
                                </GreenButton>
                            </div>
                        </div>
                        :
                        <div style={{ marginTop: "30px" }}>
                            <div>{ state.signature ? <img src={ state.signature }/> : <span style={{ color: 'yellow', background: 'grey'}}>&lt;{ t('auditPlan.placeholders.insertSignature') }&gt;</span>}</div>
                            <div style={{ paddingTop: "30px" }}>{ state.directorName ? state.directorName : <span style={{ color: 'yellow', background: 'grey'}}>&lt;{ t('auditPlan.placeholders.directorName') }&gt;</span>}</div>
                            <div style={{ paddingTop: "30px" }}>{ state.date ? moment(state.date).format('DD/MM/YYYY') : <span style={{ color: 'yellow', background: 'grey'}}>&lt;{ t('auditPlan.placeholders.date') }&gt;</span>}</div>
                            <div style={{ paddingTop: "30px" }}>
                                <BlueButton
                                    variant="contained"
                                    color="secondary"
                                    startIcon={<AddCircleOutlineTwoTone/>}
                                    onClick={this.onFooterEdit}
                                    size="small"
                                    style={{marginRight: '10px'}}
                                    disabled={isAuditor || isViewer}
                                >
                                    { t('common.edit') }
                                </BlueButton>
                            </div>
                        </div>
                }
                <Modal
                    aria-labelledby="simple-modal-title"
                    aria-describedby="simple-modal-description"
                    open={state.show}
                    onClose={() => this.closeModal(null)}
                >
                    <CommonRevisionModal latestRevisionDto={state.latestRevision} addRevision={this.addRevision}/>
                </Modal>
            <NotificationContainer/>
        </div>;
    }
}

export default withStyles(classes)(AuditPlan);